// extracted by mini-css-extract-plugin
module.exports = {"annal":"Collect_annal__f41xb","text":"Collect_text__nS-6t"};